/*!
 * 
 *   @bornfight/gocart v1.0.9
 *   
 * 
 *   Copyright (c) Bornfight (https://www.bornfight.com/)
 * 
 *   This source code is licensed under the MIT license found in the
 *   LICENSE file in the root directory of this source tree.
 *	Add Multiple Triggers
 *   
 */


class GoCart {

    constructor(options) {

        const defaults = {
            cartModalFail: '.js-go-cart-modal-fail',
            cartModalFailClose: '.js-go-cart-modal-fail-close',
            cartModal: '.js-go-cart-modal',
            cartModalClose: '.js-go-cart-modal-close',
            cartModalContent: '.js-go-cart-modal-content',
            cartModalItems: '.go-cart-item__single',
            cartDrawer: '.js-go-cart-drawer',
            cartDrawerContent: '.js-go-cart-drawer-content',
            cartDrawerSubTotal: '.js-go-cart-drawer-subtotal',
            cartDrawerFooter: '.js-go-cart-drawer-footer',
            cartDrawerClose: '.js-go-cart-drawer-close',
            cartMiniCart: '.js-go-cart-mini-cart',
            cartMiniCartContent: '.js-go-cart-mini-cart-content',
            cartMiniCartSubTotal: '.js-go-cart-mini-cart-subtotal',
            cartMiniCartFooter: '.js-go-cart-mini-cart-footer',
            cartTrigger: '.js-go-cart-trigger',
            cartOverlay: '.js-go-cart-overlay',
            cartCount: '.js-go-cart-counter',
            addToCart: '.js-go-cart-add-to-cart',
            removeFromCart: '.js-go-cart-remove-from-cart',
            removeFromCartNoDot: 'js-go-cart-remove-from-cart',
            itemQuantity: '.js-go-cart-quantity',
            itemQuantityPlus: '.js-go-cart-quantity-plus',
            itemQuantityMinus: '.js-go-cart-quantity-minus',
            cartMode: 'drawer',
            drawerDirection: 'right',
            displayModal: false,
            // eslint-disable-next-line no-template-curly-in-string
            moneyFormat: window.moneyFormat,
            labelAddedToCart: `${window.cartStrings.added_to_cart}`,
            labelCartIsEmpty: `${window.cartStrings.cart_is_empty}`,
            labelQuantity: `${window.cartStrings.quantity}:`,
            labelRemove: `${window.cartStrings.remove}`,
            labelGoToShop: `${window.cartStrings.go_to_shop}`,
            hiddenItemTag: 'hidden-product',
            cartDrawerHeaderCounter: '.go-cart-drawer__header_counter'
        };

        this.defaults = Object.assign({}, defaults, options);

        this.cartModalFail = document.querySelector(this.defaults.cartModalFail);
        this.cartModalFailClose = document.querySelector(this.defaults.cartModalFailClose);
        this.cartModal = document.querySelector(this.defaults.cartModal);
        this.cartModalClose = document.querySelectorAll(this.defaults.cartModalClose);
        this.cartModalContent = document.querySelector(this.defaults.cartModalContent);
        this.cartDrawer = document.querySelector(this.defaults.cartDrawer);
        this.cartDrawerContent = document.querySelector(this.defaults.cartDrawerContent);
        this.cartDrawerSubTotal = document.querySelector(this.defaults.cartDrawerSubTotal);
        this.cartDrawerFooter = document.querySelector(this.defaults.cartDrawerFooter);
        this.cartDrawerClose = document.querySelector(this.defaults.cartDrawerClose);
        this.cartMiniCart = document.querySelector(this.defaults.cartMiniCart);
        this.cartMiniCartContent = document.querySelector(this.defaults.cartMiniCartContent);
        this.cartMiniCartSubTotal = document.querySelector(this.defaults.cartMiniCartSubTotal);
        this.cartMiniCartFooter = document.querySelector(this.defaults.cartMiniCartFooter);
        this.cartTrigger = document.querySelectorAll(this.defaults.cartTrigger);
        this.cartOverlay = document.querySelector(this.defaults.cartOverlay);
        // this.cartCount = document.querySelector(this.defaults.cartCount);
        this.cartCount = document.querySelectorAll(this.defaults.cartCount);
        this.addToCart = document.querySelectorAll(this.defaults.addToCart);
        this.removeFromCart = this.defaults.removeFromCart;
        this.removeFromCartNoDot = this.defaults.removeFromCartNoDot;
        this.itemQuantity = this.defaults.itemQuantity;
        this.itemQuantityPlus = this.defaults.itemQuantityPlus;
        this.itemQuantityMinus = this.defaults.itemQuantityMinus;
        this.cartMode = this.defaults.cartMode;
        this.drawerDirection = this.defaults.drawerDirection;
        this.displayModal = this.defaults.displayModal;
        this.moneyFormat = this.defaults.moneyFormat;
        this.labelAddedToCart = this.defaults.labelAddedToCart;
        this.labelCartIsEmpty = this.defaults.labelCartIsEmpty;
        this.labelQuantity = this.defaults.labelQuantity;
        this.labelRemove = this.defaults.labelRemove;
        this.hiddenItemTag = this.defaults.hiddenItemTag;
        this.labelGoToShop = this.defaults.labelGoToShop;

        this.cartDrawerHeaderCounter = document.querySelector(defaults.cartDrawerHeaderCounter);

        // Cache for preloaded images
        this.imageCache = new Map();

        this.init();

    }

    get isDrawerMode() {
        return this.cartMode === 'drawer';
    }

    setupAtcButtons() {
        this.addToCart = document.querySelectorAll(this.defaults.addToCart);
        if (this.addToCart) {
            this.addToCart.forEach((item) => {
                item.addEventListener('click', (event) => {
                    event.preventDefault();
                    let form = item.parentNode;
                    while ('form' !== form.tagName.toLowerCase()) {
                        form = form.parentNode;
                    }
                    
                    // Preload product image immediately when ATC is clicked
                    const productImageElement = form.querySelector('img[src*="product"], img[data-src*="product"], .product-image img, [class*="product"] img');
                    if (productImageElement) {
                        const imageSrc = productImageElement.src || productImageElement.dataset.src;
                        if (imageSrc) {
                            this.preloadSingleImage(imageSrc);
                        }
                    }
                    
                    const formID = form.getAttribute('id');
                    this.addItemToCart(formID);
                });
            });
        }
    }

    init() {
        this.fetchCart();
        this.preloadCartImages();

        if (this.isDrawerMode) {
            this.setDrawerDirection();
        }

        // Watch for quickview modal being shown
        this.setupQuickviewObserver();

        /*
        document.addEventListener('click', (event) => {
            if (event.target.matches(this.defaults.addToCart)) {
                event.preventDefault();
                let item = event.target;
                let form = item.parentNode;
                while ('form' !== form.tagName.toLowerCase()) {
                    form = form.parentNode;
                }
                const formID = form.getAttribute('id');
                this.addItemToCart(formID);
            }
        }, false);
        */

        this.setupAtcButtons()

        this.cartTrigger.forEach((item) => {
            item.addEventListener('mouseenter', () => {
                this.preloadCartImages();
            });
            
            item.addEventListener('click', (event) => {
                event.preventDefault();
                this.preloadCartImages();
                
                if (this.isDrawerMode) {
                    this.openCartDrawer();
                } else {
                    this.openMiniCart();
                }
                this.openCartOverlay();
            });
        });

        this.cartOverlay.addEventListener('click', () => {
            this.closeFailModal();
            this.closeCartModal();
            if (this.isDrawerMode) {
                this.closeCartDrawer();
            } else {
                this.closeMiniCart();
            }
            this.closeCartOverlay();
        });

        if (this.isDrawerMode) {
            this.cartDrawerClose?.addEventListener('click', () => {
                this.closeCartDrawer();
                this.closeCartOverlay();
            });
        }

        if (this.displayModal) {
            this.cartModalClose.forEach((item) => {
                item.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.closeFailModal();
                    this.closeCartModal();
                    if (this.isDrawerMode) {
                        this.closeCartDrawer();
                    } else {
                        this.closeMiniCart();
                    }
                    this.closeCartOverlay();
                });
            });
        }

        this.cartModalFailClose.addEventListener('click', () => {
            this.closeFailModal();
            this.closeCartModal();
            if (this.isDrawerMode) {
                this.closeCartDrawer();
            } else {
                this.closeMiniCart();
            }
            this.closeCartOverlay();
        });

        document.addEventListener('currencyChanged', () => {
            this.fetchCart();
        });
    }

    preloadSingleImage(imageUrl) {
        if (!imageUrl || this.imageCache.has(imageUrl)) {
            return Promise.resolve();
        }

        return new Promise((resolve) => {
            // Remove any existing preload links for this image to avoid duplicates
            const existingLinks = document.querySelectorAll(`link[href="${imageUrl}"]`);
            existingLinks.forEach(link => link.remove());
            
            // Create link elements for preloading with high priority
            const link = document.createElement('link');
            link.rel = 'preload';
            link.as = 'image';
            link.href = imageUrl;
            link.fetchPriority = 'high';
            document.head.appendChild(link);
            
            // Create Image objects for immediate loading with high priority
            const img = new Image();
            img.fetchPriority = 'high';
            img.loading = 'eager';
            
            // Store in cache when loaded
            img.onload = () => {
                this.imageCache.set(imageUrl, img);
                // Force immediate decode for faster display
                if (img.decode) {
                    img.decode().then(() => resolve()).catch(() => resolve());
                } else {
                    resolve();
                }
            };
            
            img.onerror = () => {
                // Silent fail for image preloading
                resolve();
            };
            
            // Set src last to trigger loading
            img.src = imageUrl;
        });
    }

    preloadCartImages() {
        const cartUrl = window.Shopify.routes.root + 'cart.js';
        
        window.fetch(cartUrl, {
            credentials: 'same-origin',
            method: 'GET',
        })
        .then((response) => response.json())
        .then((cart) => {
            if (cart.items && cart.items.length > 0) {
                cart.items.forEach((item) => {
                    if (item.image) {
                        this.preloadSingleImage(item.image);
                    }
                });
            }
        })
        .catch((error) => {
            // Silent fail for preloading
        });
    }

    setupQuickviewObserver() {
        document.addEventListener('quickview:loaded', () => {
            this.setupAtcButtons();
        });
        
        const handleModalAppear = () => {
            const quickviewModal = document.getElementById('quickview-modal');
            if (quickviewModal) {
                
                const observer = new MutationObserver((mutations) => {
                    mutations.forEach((mutation) => {
                        if (mutation.attributeName === 'class') {
                            const isVisible = quickviewModal.classList.contains('is-visible');
                            if (isVisible) {
                                setTimeout(() => this.setupAtcButtons(), 100);
                            }
                        }
                    });
                });

                observer.observe(quickviewModal, {
                    attributes: true,
                    attributeFilter: ['class']
                });
                
                clearInterval(modalCheckInterval);
            }
        };
        
        const modalCheckInterval = setInterval(handleModalAppear, 300);
        handleModalAppear();
    }

    fetchCart(callback) {
        const cartUrl = window.Shopify.routes.root + 'cart?view=json';
        
        window.fetch(cartUrl, {
            credentials: 'same-origin',
            method: 'GET',
        })
            .then((response) => response.text())
            .then((cartText) => { 
                eval(cartText); 
                
                // Store the cart data to prevent it from being overridden
                const cartData = { ...window.cart };
                
                this.fetchHandler(cartData, callback);
            })
            .catch((error) => {
                this.ajaxRequestFail();
                throw new Error(error);
            });
    }

    addItemToCart(formID) {
        const currentQuantity = document.querySelector(".js-qty__num")?.value || 1;
        const form = document.querySelector(`#${formID}`);
        const formData = serialize(form, { hash: true });
        formData.quantity = currentQuantity;
    
        const cartUrl = window.Shopify.routes.root + 'cart.js';
    
        window.fetch(cartUrl, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        .then((response) => response.json())
        .then((cart) => {
            return window.fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });
        })
        .then((response) => {
            if (!response) return null;
            return response.json();
        })
        .then((product) => {
            if (!product) return;

            // Preload the product image immediately
            if (product.image) {
                this.preloadSingleImage(product.image);
            }

            this.addItemToCartHandler(product);
            
            // Refresh cart to get updated discount information
            setTimeout(() => {
                this.fetchCart();
            }, 500);
            
            return fetch(window.Shopify.routes.root + 'cart.js');
        })
        .then((response) => {
            if (!response) return;
            return response.json();
        })
        .catch((error) => {
            this.ajaxRequestFail();
        });
    }
    
    removeItem(line) {
        const quantity = 0;
        window.fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify({quantity, line}),
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => {
                if (response.status === 422) {
                    // Handle any error responses
                    return response.json().then(errorData => {
                        this.showInventoryError(errorData.message || errorData.description);
                        this.fetchCart();
                    });
                }
                return response.json();
            })
            .then((data) => {
                if (data && !data.status) {
                    // Only refresh cart if it was a successful update
                    this.fetchCart();
                }
            })
            .catch((error) => {
                this.ajaxRequestFail();
                throw new Error(error);
            });
    }

    changeItemQuantity(line, quantity) {
        window.fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify({quantity, line}),
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => {
                if (response.status === 422) {
                    // Handle inventory limitation error
                    return response.json().then(errorData => {
                        this.showInventoryError(errorData.message || errorData.description);
                        // Refresh cart to show current state
                        this.fetchCart();
                    });
                }
                return response.json();
            })
            .then((data) => {
                if (data && !data.status) {
                    // Only refresh cart if it was a successful update
                    this.fetchCart();
                }
            })
            .catch((error) => {
                this.ajaxRequestFail();
                throw new Error(error);
            });
    }

    showInventoryError(message) {
        // Create and show inventory error message
        const errorMessage = document.createElement('div');
        errorMessage.className = 'inventory-error-message';
        errorMessage.style.cssText = `
            position: fixed;
            top: 20px;
            right: 20px;
            background: #dc3545;
            color: white;
            padding: 12px 20px;
            border-radius: 16px;
            z-index: 10001;
            font-family: var(--body1-font);
            font-size: 14px;
            box-shadow: 0 4px 12px rgba(0,0,0,0.15);
            animation: slideInRight 0.3s ease;
            max-width: 300px;
            word-wrap: break-word;
        `;
        
        errorMessage.textContent = message;
        document.body.appendChild(errorMessage);
        
        // Remove error message after 4 seconds
        setTimeout(() => {
            if (errorMessage.parentNode) {
                errorMessage.style.animation = 'slideOutRight 0.3s ease';
                setTimeout(() => {
                    if (errorMessage.parentNode) {
                        errorMessage.parentNode.removeChild(errorMessage);
                    }
                }, 300);
            }
        }, 4000);
    }

    cartItemCount(cart) {
        // Update all cart counters on the page
        if (this.cartCount) {
            this.cartCount.forEach(counter => {
                if (counter) {
                    counter.innerHTML = cart.item_count;
                }
            });
        }
        
        // Update cart drawer header counter with localized item label
        if (this.cartDrawerHeaderCounter) {
            const strings = window.cartStrings || {};
            const singular = strings.go_cart_item_singular || 'product';
            const plural = strings.go_cart_item_plural || 'products';
            const productText = cart.item_count === 1 ? singular : plural;
            const counterText = ` ${cart.item_count} ${productText}`;

            this.cartDrawerHeaderCounter.innerHTML = `<span ${this.weglotDynamicTextAttributes(counterText)}>${this.escapeHtml(counterText)}</span>`;
            this.refreshWeglotDynamic(this.cartDrawerHeaderCounter);
        }
    }

    fetchAndOpenCart() {
        this.fetchCart(() => {
            if (this.isDrawerMode) {
                this.openCartDrawer();
            } else {
                this.openMiniCart();
            }
            this.openCartOverlay();
        });
    }

    fetchAndOpenModal(product) {
        this.fetchCart(() => {
            this.renderCartModal(product);
            this.openCartModal();
            this.openCartOverlay();
        });
    }

    fetchHandler(cart, callback) {
        this.cartItemCount(cart);
        
        // Preload images when cart is updated
        this.preloadCartImages();
        
        if (this.isDrawerMode) {
            if (cart.item_count === 0) {
                this.renderBlankCartDrawer();
                this.cartDrawerFooter.classList.add('is-invisible');
            } else {
                this.renderDrawerCart(cart);
                this.cartDrawerFooter.classList.remove('is-invisible');
                if ((typeof callback) === 'function') {
                    callback(cart);
                }
            }
        } else if (cart.item_count === 0) {
            this.renderBlankMiniCart();
            this.cartMiniCartFooter.classList.add('is-invisible');
        } else {
            this.renderMiniCart(cart);
            this.cartMiniCartFooter.classList.remove('is-invisible');
            if ((typeof callback) === 'function') {
                callback(cart);
            }
        }
    }

    addItemToCartHandler(product) {
        return this.displayModal ? this.fetchAndOpenModal(product) : this.fetchAndOpenCart();
    }

    ajaxRequestFail() {
        this.openFailModal();
        this.openCartOverlay();
    }

    renderCartModal(product) {
        this.clearCartModal();
        let productVariant = product.variant_title;
        if (productVariant === null) {
            productVariant = '';
        } else {
            productVariant = `(${productVariant})`;
        }
        const cartSingleProduct = `
          <div class="go-cart-modal-item">
            <div class="go-cart-item__image" style="background-image: url(${product.image});"></div>
            <div class="go-cart-item__info">
              ${product.product_title.includes(this.hiddenItemTag) ?
            `<p class="go-cart-item__title" ${this.weglotDynamicTextAttributes(`${product.product_title} ${productVariant}`)}>${this.escapeHtml(`${product.product_title} ${productVariant}`)}</p>` :
            `<a href="${product.url}" class="go-cart-item__title" ${this.weglotDynamicTextAttributes(`${product.product_title} ${productVariant}`)}>${this.escapeHtml(`${product.product_title} ${productVariant}`)}</a>`}
              <span ${this.weglotDynamicTextAttributes(this.labelAddedToCart)}>${this.escapeHtml(this.labelAddedToCart)}</span>
            </div>
          </div>`;
        this.cartModalContent.innerHTML += cartSingleProduct;
        this.refreshWeglotDynamic(this.cartModalContent);
    }

    toTitleCase(str) {
        return str.replace(/\w\S*/g, (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());
    }

    escapeHtml(value) {
        const div = document.createElement('div');
        div.textContent = String(value || '');
        return div.innerHTML;
    }

    escapeAttribute(value) {
        return this.escapeHtml(value).replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    weglotDynamicTextAttributes(value) {
        return `data-weglot-dynamic="text" data-weglot-source="${this.escapeAttribute(value)}"`;
    }

    weglotDynamicAttributeAttributes(attributes) {
        const names = Object.keys(attributes).filter(Boolean);
        const sources = names.map((name) => `data-weglot-source-${name}="${this.escapeAttribute(attributes[name])}"`);

        return `data-weglot-dynamic-attributes="${names.join(',')}" ${sources.join(' ')}`;
    }

    refreshWeglotDynamic(root) {
        if (!root) return;

        root.dispatchEvent(new CustomEvent('fk:dynamic-content:rendered', { bubbles: true, detail: { root } }));

        if (window.fkWeglotDynamic && typeof window.fkWeglotDynamic.refresh === 'function') {
            window.fkWeglotDynamic.refresh(root);
        }
    }

    getLineItemPropertyLabel(key) {
        const strings = window.cartStrings || {};
        const labels = {
            'jersey sponsor': strings.jersey_sponsor || 'Sponsor',
            'sponzor': strings.jersey_sponsor || 'Sponsor',
            'jersey print type': strings.jersey_print_type || 'Print',
            'tip printa': strings.jersey_print_type || 'Print',
            'jersey player': strings.jersey_player || 'Player',
            'igrač': strings.jersey_player || 'Player',
            'jersey custom name': strings.jersey_custom_name || 'Name',
            'custom ime': strings.jersey_custom_name || 'Name',
            'jersey custom number': strings.jersey_custom_number || 'Number',
            'custom broj': strings.jersey_custom_number || 'Number'
        };

        return labels[String(key || '').toLowerCase()] || String(key || '').replace(/_/g, ' ');
    }

    renderLineItemProperties(item) {
        const properties = item.properties || {};

        const prop = Object.fromEntries(
            Object.entries(properties)
                .filter(([key]) => key)
                .map(([key, value]) => [key.toLowerCase(), value])
        );

        const getFirst = (...names) => {
            for (const name of names) {
                const val = prop[name.toLowerCase()];
                if (val) return val;
            }
            return '';
        };

        const player = getFirst('Jersey player', 'Igrač');
        const customName = getFirst('Jersey custom name', 'Custom ime');
        const customNumber = getFirst('Jersey custom number', 'Custom broj');
        const printDetails = player || [customName, customNumber].filter(Boolean).join(' ');
        const printTypeKeys = new Set(['jersey print type', 'tip printa']);
        const handledKeys = new Set(['jersey player', 'igrač', 'jersey custom name', 'custom ime', 'jersey custom number', 'custom broj']);

        const rows = Object.entries(properties)
            .filter(([key, value]) => {
                if (!key || !value || key.startsWith('_')) return false;
                return !handledKeys.has(key.toLowerCase());
            })
            .map(([key, value]) => `
                <div class="go-cart-item__property">
                    <span class="go-cart-item__property-label" ${this.weglotDynamicTextAttributes(`${this.getLineItemPropertyLabel(key)}:`)}>${this.escapeHtml(this.getLineItemPropertyLabel(key))}:</span>
                    <span class="go-cart-item__property-value">${this.escapeHtml(value)}${printTypeKeys.has(key.toLowerCase()) && printDetails ? ` - ${this.escapeHtml(printDetails)}` : ''}</span>
                </div>
            `)
            .join('');

        return rows ? `<div class="go-cart-item__properties">${rows}</div>` : '';
    }

    renderDrawerCart(cart) {
        this.clearCartDrawer();
        const locale = Shopify.locale || 'en';
    
        cart.items.forEach((item, index) => {
            let itemVariant = item.variant_title || '';
            const productTitle = item.product_title;
    
            const cartSingleProduct = `
                <div class="go-cart-item__single" data-line="${Number(index + 1)}" data-variant-id="${item.variant_id}">
                    <div class="go-cart-item__info-wrapper">
                        <a href="${item.url}" class="go-cart-item__image">
                            <img src="${item.image}" alt="${this.escapeAttribute(item.product_title)}" loading="eager" fetchpriority="high">
                        </a>
                        <div class="go-cart-item__info">
                            <a href="${item.url}" class="go-cart-item__title" ${this.weglotDynamicTextAttributes(productTitle)}>${this.escapeHtml(productTitle)}</a>
                            ${item.product_title.includes("GIFT CARD") ? "" : `<div class="go-cart-item__variant body1" ${this.weglotDynamicTextAttributes(itemVariant)}>${this.escapeHtml(itemVariant)}</div>`}
                            ${this.renderLineItemProperties(item)}
                            ${this.renderAdvancedPriceContainer(item, this.moneyFormat)}
                            <div class="go-cart-price-qty">
                                <div class="go-cart-item__quantity">
                                    <span class="go-cart-item__quantity-button cta cta-ps-primary js-go-cart-quantity-minus"><span>-</span></span>
                                    <input class="go-cart-item__quantity-number js-go-cart-quantity" type="number" value="${item.quantity}" disabled>
                                    <span class="go-cart-item__quantity-button cta cta-ps-primary js-go-cart-quantity-plus"><span>+</span></span>
                                </div>
                                <a href="#" class="go-cart-item__remove ${this.removeFromCartNoDot}" aria-label="${this.escapeAttribute(window.variantStrings.remove)}" ${this.weglotDynamicAttributeAttributes({ 'aria-label': window.variantStrings.remove })}>
                                    <span class="go-cart-item__remove-icon" aria-hidden="true"></span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>`;
    
            this.cartDrawerContent.innerHTML += cartSingleProduct;
        });
    
        this.cartDrawerSubTotal.innerHTML = formatMoney(cart.total_price, this.moneyFormat);
        
        // Remove is-invisible from both the footer and the subtotal parent
        this.cartDrawerFooter.classList.remove('is-invisible');
        this.cartDrawerSubTotal.parentNode.classList.remove('is-invisible');
        this.refreshWeglotDynamic(this.cartDrawerContent);
        
        this.setupCartItemListeners();
    }

    renderAdvancedPriceContainer(item, moneyFormat) {
        const displayPrice = window.memberPricing?.getCartLineDisplayPrice
            ? window.memberPricing.getCartLineDisplayPrice(item)
            : {
                price: Number(item.final_line_price ?? item.line_price ?? 0),
                compareAtPrice: Number(item.original_line_price ?? item.line_price ?? 0)
            };
        
        if (displayPrice.compareAtPrice && displayPrice.compareAtPrice > displayPrice.price) {
            return `
                <div class="price-container">
                    <div class="go-cart-item__price compare-at">${formatMoney(displayPrice.compareAtPrice, moneyFormat)}</div>
                    <div class="go-cart-item__price sale">${formatMoney(displayPrice.price, moneyFormat)}</div>
                </div>
            `;
        } else {
            return `
                <div class="price-container">
                    <div class="go-cart-item__price">${formatMoney(displayPrice.price, moneyFormat)}</div>
                </div>
            `;
        }
    }

    renderMiniCart(cart) {
        this.clearMiniCart();
        cart.items.forEach((item, index) => {
            let itemVariant = item.variant_title;
            if (itemVariant === null) {
                itemVariant = '';
            }
            const productTitle = item.product_title;
            const cartSingleProduct = `
              <div class="go-cart-item__single" data-line="${Number(index + 1)}" data-variant-id="${item.variant_id}">
                <div class="go-cart-item__info-wrapper">
                    <div class="go-cart-item__image" style="background-image: url(${item.image});"></div>
                    <div class="go-cart-item__info">
                        ${item.product_tags.includes(this.hiddenItemTag) ?
                `<p class="go-cart-item__title h3" ${this.weglotDynamicTextAttributes(productTitle)}>${this.escapeHtml(productTitle)}</p>` :
                `<a href="${item.url}" class="go-cart-item__title h3" ${this.weglotDynamicTextAttributes(productTitle)}>${this.escapeHtml(productTitle)}</a>`}
                        <div class="go-cart-item__variant" ${this.weglotDynamicTextAttributes(itemVariant)}>${this.escapeHtml(itemVariant)}</div>
                        ${this.renderLineItemProperties(item)}
                        <div class="go-cart-item__quantity">
                          ${item.product_tags.includes(this.hiddenItemTag) ? "" : `<span class="go-cart-item__quantity-button cta cta-ps-primary js-go-cart-quantity-minus"><span>-</span></span>`}
                          <input class="go-cart-item__quantity-number js-go-cart-quantity" type="number" value="${item.quantity}" disabled>
                          ${item.product_tags.includes(this.hiddenItemTag) ? "" : `<span class="go-cart-item__quantity-button cta cta-ps-primary js-go-cart-quantity-plus"><span>+</span></span>`}
                        </div>
                    </div>
                </div>
                ${this.renderAdvancedPriceContainer(item, this.moneyFormat)}
                <a class="go-cart-item__remove ${this.removeFromCartNoDot}" aria-label="${this.escapeAttribute(this.labelRemove)}" ${this.weglotDynamicAttributeAttributes({ 'aria-label': this.labelRemove })}>
                    <span class="go-cart-item__remove-icon" aria-hidden="true"></span>
                </a>
              </div>`;
            this.cartMiniCartContent.innerHTML += cartSingleProduct;
        });
        this.cartMiniCartSubTotal.innerHTML = formatMoney(cart.total_price, this.moneyFormat);
        this.cartMiniCartSubTotal.parentNode.classList.remove('is-invisible');
        this.refreshWeglotDynamic(this.cartMiniCartContent);
        const removeFromCart = document.querySelectorAll(this.removeFromCart);
        removeFromCart.forEach((item) => {
            item.addEventListener('click', () => {
                GoCart.removeItemAnimation(item.parentNode);
                const line = item.parentNode.getAttribute('data-line');
                this.removeItem(line);
            });
        });
        const itemQuantityPlus = document.querySelectorAll(this.itemQuantityPlus);
        itemQuantityPlus.forEach((item) => {
            item.addEventListener('click', () => {
                const line = item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
                const quantity = Number(item.parentNode.querySelector(this.itemQuantity).value) + 1;
                this.changeItemQuantity(line, quantity);
            });
        });
        const itemQuantityMinus = document.querySelectorAll(this.itemQuantityMinus);
        itemQuantityMinus.forEach((item) => {
            item.addEventListener('click', () => {
                const line = item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
                const quantity = Number(item.parentNode.querySelector(this.itemQuantity).value) - 1;
                this.changeItemQuantity(line, quantity);
                if (Number((item.parentNode.querySelector(this.itemQuantity).value - 1)) === 0) {
                    GoCart.removeItemAnimation(item.parentNode.parentNode.parentNode.parentNode.parentNode);
                }
            });
        });
    }

    setupCartItemListeners() {
        const removeFromCart = document.querySelectorAll(this.removeFromCart);
        removeFromCart.forEach((item) => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                const parent = item.parentNode.parentNode.parentNode.parentNode
                GoCart.removeItemAnimation(parent);
                const line = parent.getAttribute('data-line');
                this.removeItem(line);
            });
        });
        const itemQuantityPlus = document.querySelectorAll(this.itemQuantityPlus);
        itemQuantityPlus.forEach((item) => {
            item.addEventListener('click', () => {
                const line = item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
                const quantity = Number(item.parentNode.querySelector(this.itemQuantity).value) + 1;
                this.changeItemQuantity(line, quantity);
            });
        });
        const itemQuantityMinus = document.querySelectorAll(this.itemQuantityMinus);
        itemQuantityMinus.forEach((item) => {
            item.addEventListener('click', () => {
                const line = item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
                const quantity = Number(item.parentNode.querySelector(this.itemQuantity).value) - 1;
                this.changeItemQuantity(line, quantity);
                if (Number((item.parentNode.querySelector(this.itemQuantity).value - 1)) === 0) {
                    GoCart.removeItemAnimation(item.parentNode.parentNode.parentNode.parentNode.parentNode);
                }
            });
        });
    }

    renderBlankCartDrawer() {
        this.cartDrawerSubTotal.parentNode.classList.add('is-invisible');
        const locale = Shopify.locale || 'hr';
        const productUrlPrefix = locale === 'hr' ? '' : `/${locale}`;
        this.clearCartDrawer();
        this.cartDrawerContent.innerHTML = `<div class="go-cart__empty"><span ${this.weglotDynamicTextAttributes(this.labelCartIsEmpty)}>${this.escapeHtml(this.labelCartIsEmpty)}</span><a class="button cta cta-ps-primary" href="${productUrlPrefix}/collections/all"><span ${this.weglotDynamicTextAttributes(this.labelGoToShop)}>${this.escapeHtml(this.labelGoToShop)}</span></a></div>`;
        this.refreshWeglotDynamic(this.cartDrawerContent);
    }

    renderBlankMiniCart() {
        this.cartMiniCartSubTotal.parentNode.classList.add('is-invisible');
        const locale = Shopify.locale || 'hr';
        const productUrlPrefix = locale === 'hr' ? '' : `/${locale}`;
        this.clearMiniCart();
        this.cartMiniCartContent.innerHTML = `<div class="go-cart__empty"><span ${this.weglotDynamicTextAttributes(this.labelCartIsEmpty)}>${this.escapeHtml(this.labelCartIsEmpty)}</span><a class="button cta cta-ps-primary" href="${productUrlPrefix}/collections/all"><span ${this.weglotDynamicTextAttributes(this.labelGoToShop)}>${this.escapeHtml(this.labelGoToShop)}</span></a></div>`;
        this.refreshWeglotDynamic(this.cartMiniCartContent);
    }

    reloadAjaxContent() {
        this.fetchAndOpenCart();
    }

    clearCartDrawer() {
        this.cartDrawerContent.innerHTML = '';
    }

    clearMiniCart() {
        this.cartMiniCartContent.innerHTML = '';
    }

    clearCartModal() {
        this.cartModalContent.innerHTML = '';
    }

    openCartDrawer() {
        this.cartDrawer.classList.add('is-open');
        document.querySelector('body').classList.add('drawer-open');
    }

    closeCartDrawer() {
        this.cartDrawer.classList.remove('is-open');
        document.querySelector('body').classList.remove('drawer-open');
    }

    openMiniCart() {
        this.cartMiniCart.classList.add('is-open');
    }

    closeMiniCart() {
        this.cartMiniCart.classList.remove('is-open');
    }

    openFailModal() {
        this.cartModalFail.classList.add('is-open');
    }

    closeFailModal() {
        this.cartModalFail.classList.remove('is-open');
    }

    openCartModal() {
        this.cartModal.classList.add('is-open');
    }

    closeCartModal() {
        this.cartModal.classList.remove('is-open');
    }

    openCartOverlay() {
        this.cartOverlay.classList.add('is-open');
    }

    closeCartOverlay() {
        this.cartOverlay.classList.remove('is-open');
    }

    static removeItemAnimation(item) {
        item.classList.add('is-invisible');
    }

    setDrawerDirection() {
        this.cartDrawer.classList.add(`go-cart__drawer--${this.drawerDirection}`);
    }
}

//export default GoCart;
